export enum ColumnAccessor {
  _checkbox = '_checkbox',
  _productGroupKey = '_productGroupKey',
  buyingPrice = 'buyingPrice',
  position = 'position',
  chooseDiscount = 'chooseDiscount',
  choosePrice = 'choosePrice',
  couponExpirationDate = 'couponExpirationDate',
  couponHowToUse = 'couponHowToUse',
  couponTerms = 'couponTerms',
  description = 'description',
  discountedPrice = 'discountedPrice',
  gtin = 'gtin',
  images = 'images',
  isBestSeller = 'isBestSeller',
  listPrice = 'listPrice',
  madeIn = 'madeIn',
  marginPercentage = 'marginPercentage',
  name = 'name',
  potentialSalesVolume = 'potentialSalesVolume',
  productType = 'productType',
  shippingPrice = 'shippingPrice',
  shopifyVariantId = 'shopifyVariantId',
  sku = 'sku',
  sourceUrl = 'sourceUrl',
  stockQuantity = 'stockQuantity',
  validationErrors = 'validationErrors',
  vatRate = 'vatRate',
  eeePrice = 'eeePrice',
}

export enum ColumnAccessorSortable {
  buyingPrice = ColumnAccessor.buyingPrice,
  position = ColumnAccessor.position,
  chooseDiscount = ColumnAccessor.chooseDiscount,
  choosePrice = ColumnAccessor.choosePrice,
  couponExpirationDate = ColumnAccessor.couponExpirationDate,
  couponHowToUse = ColumnAccessor.couponHowToUse,
  couponTerms = ColumnAccessor.couponTerms,
  description = ColumnAccessor.description,
  discountedPrice = ColumnAccessor.discountedPrice,
  gtin = ColumnAccessor.gtin,
  isBestSeller = ColumnAccessor.isBestSeller,
  listPrice = ColumnAccessor.listPrice,
  madeIn = ColumnAccessor.madeIn,
  marginPercentage = ColumnAccessor.marginPercentage,
  potentialSalesVolume = ColumnAccessor.potentialSalesVolume,
  productType = ColumnAccessor.productType,
  shippingPrice = ColumnAccessor.shippingPrice,
  shopifyVariantId = ColumnAccessor.shopifyVariantId,
  sku = ColumnAccessor.sku,
  stockQuantity = ColumnAccessor.stockQuantity,
  sourceUrl = ColumnAccessor.sourceUrl,
  vatRate = ColumnAccessor.vatRate,
  eeePrice = ColumnAccessor.eeePrice,
}
